import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import PayrollSection from 'main/stores/payroll/PayrollSection';

class PayrollDiff extends DomainObject {
  recordedOn;
  payrollSections;
  newHire;
  terminated;

  _relations = {
    payrollSections: [PayrollSection]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      recordedOn: observable,
      payrollSections: observable,
      newHire: observable,
      terminated: observable
    });

    this.merge(other);
  }
}

export default PayrollDiff;
